import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'

interface IFilterParentPartnersParams {
  originalPartner: IPartner
  externalPartner: IPartner
}

export const filterParentPartners = ({
  originalPartner,
  externalPartner,
}: IFilterParentPartnersParams) => {
  if (originalPartner.hierarchyType === PartnerHierarchyType.HEADQUARTERS) {
    return true
  } else {
    return (
      externalPartner.hierarchyType !== PartnerHierarchyType.HEADQUARTERS ||
      externalPartner.partnerId !== originalPartner.topPartnerId
    )
  }
}
